import Vue from 'vue';

export default {
    getProduction() {
        return Vue.prototype.$axiosMainClient.get('dailycapacities/production');
    },
};
